var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("settings-editor-base", {
    attrs: { label: _vm.label },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var inputId = ref.inputId
          return [
            _c(
              "div",
              { staticClass: "row" },
              [
                _c("div", { staticClass: "col-12" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: { id: inputId },
                      on: { click: _vm.showPicker }
                    },
                    [_vm._v("\n                    Browse\n                ")]
                  ),
                  _vm._v(" "),
                  _vm.hasImage
                    ? _c("i", {
                        staticClass:
                          "fas fa-lg fa-trash-alt mdb-icon-btn delete float-right mt-2",
                        attrs: { "aria-hidden": "true" },
                        on: {
                          click: function($event) {
                            $event.stopPropagation()
                            return _vm.promptRemoveFile($event)
                          }
                        }
                      })
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.name
                  ? _c("div", { staticClass: "col-12" }, [
                      _c("label", [_vm._v(" " + _vm._s(_vm.name) + " ")])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _c("modal", {
                  ref: "pickerModal",
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "modal-header",
                        fn: function() {
                          return undefined
                        },
                        proxy: true
                      },
                      {
                        key: "modal-body",
                        fn: function() {
                          return [
                            _c("media-library", {
                              attrs: { mediaId: _vm.mediaId },
                              on: { "file-picked": _vm.filePicked }
                            })
                          ]
                        },
                        proxy: true
                      },
                      {
                        key: "modal-footer",
                        fn: function() {
                          return undefined
                        },
                        proxy: true
                      }
                    ],
                    null,
                    true
                  )
                })
              ],
              1
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }